import React from "react";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaFax,
  FaEnvelope,
  FaWeixin,
  FaGlobe,
} from "react-icons/fa";
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import ImageLoader from "../ImageLoader/ImageLoader";
import { useTranslation } from "react-i18next";

const SalesContact = () => {
  const { t } = useTranslation();

  return (
    <ImageLoader>
      <Container>
        <Row className="section">
          <Col md={6}>
            <AnimateOnScroll animationType="slideRight">
              <h2>{t("salescontact_main_title")}</h2>
              <p>{t("salescontact_main_p")}</p>
              <img
                src="/images/02_02.jpg"
                alt="One Oasis"
                className="fullimg"
              />
            </AnimateOnScroll>
          </Col>
          <Col md={6} className="text-start greybox">
            <AnimateOnScroll animationType="slideLeft">
              <h3>{t("salescontact_form_title")}</h3>
              <Form
                action="mailto:enquiry@grandoasismacau.com"
                method="post"
                encType="text/plain"
              >
                <Form.Group className="mb-3" controlId="formBasicName">
                  <Form.Label>{t("salescontact_form_name")}</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder={t("salescontact_form_name_placeholder")}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>{t("salescontact_form_email")}</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder={t("salescontact_form_email_placeholder")}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicMessage">
                  <Form.Label>{t("salescontact_form_message")}</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="message"
                    placeholder={t("salescontact_form_message_placeholder")}
                  />
                </Form.Group>

                <div className="text-end">
                  <Button variant="primary" type="submit">
                    {t("salescontact_form_submit")}
                  </Button>
                </div>
              </Form>
              <div className="contact-info-grid mt-4">
                <FaMapMarkerAlt />
                <div>{t("salescontact_address")}</div>
                <FaPhone />
                <div>
                  (853) 2823 2323
                  <br />
                  (852) 2522 6888
                  <br />
                  (86) 180 6388 1905
                  <br />
                  (853) 2832 3828
                </div>
                <FaEnvelope />
                <div>
                  <a href="mailto:enquiry@grandoasismacau.com">
                    enquiry@grandoasismacau.com
                  </a>
                </div>
                <FaWeixin />
                <div>{t("salescontact_wechat")}</div>
                <FaGlobe />
                <div>
                  <a
                    href="http://www.grandoasismacau.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    www.grandoasismacau.com
                  </a>
                </div>
              </div>
            </AnimateOnScroll>
          </Col>
        </Row>
      </Container>
    </ImageLoader>
  );
};

export default SalesContact;
